export default __webpack_public_path__ + "static/media/CO2_white.1984889b.png";